import { render, staticRenderFns } from "./weChatMain.vue?vue&type=template&id=55edfc34&scoped=true&"
import script from "./weChatMain.vue?vue&type=script&scoped=true&lang=js&"
export * from "./weChatMain.vue?vue&type=script&scoped=true&lang=js&"
import style0 from "./weChatMain.vue?vue&type=style&index=0&id=55edfc34&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55edfc34",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/merchant_5Yxh/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('55edfc34')) {
      api.createRecord('55edfc34', component.options)
    } else {
      api.reload('55edfc34', component.options)
    }
    module.hot.accept("./weChatMain.vue?vue&type=template&id=55edfc34&scoped=true&", function () {
      api.rerender('55edfc34', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/decoration/weChatMain.vue"
export default component.exports